const colors = [
    '#fa7507',
    '#38B2AC',
    '#48BB78',
    '#4299E1',
    '#667EEA',
    '#9F7AEA',
    '#F56565',
    '#267346',
    '#1c7aad',
    '#ff5675',
    '#0960bd',
    '#009688',
    '#ff5c93',
    '#0096c7',
    '#9c27b0',
    '#0084f4',
    '#383f45',
    '#843900',
    '#d71345',
    '#6950a1',
    '#a3cf62',
    '#ae6642',
    '#fcaf17',
    '#840228',
    '#11264f'
];

// export function colorByIndex(index) {
//     return colors[index % colors.length] || colors[0];
// }

const usedColors = new Set(); // 用于记录已使用的颜色

export function getRandomColor () {
    let availableColors = colors.filter(color => !usedColors.has(color)); // 过滤出尚未使用的颜色
    if (availableColors.length === 0) {
        // 如果所有颜色都已使用，则重新开始使用所有颜色
        availableColors = colors;
        usedColors.clear();
    }
    const randomIndex = Math.floor(Math.random() * availableColors.length);
    const randomColor = availableColors[randomIndex];
    usedColors.add(randomColor); // 将选中的颜色标记为已使用
    return randomColor;
}